import React, { useState } from 'react';
import Button from "../../assets/buttons/btnPrimary"
import ImgError404 from '../../assets/images/error404.png'
import './error404.css'

const Error = () => {
   
  return (
    <>
<div className='bodyError404'>
  <div className='error404ContainerContent'>
  <div className='error404ContainerText'>
    <p className='error404TextOne'>We are sorry for it</p>
    <h2 className='error404Title'>Error 404</h2>
    <p className='error404TextTwo'>The page you are looking is not available</p>
    </div>
    <img src={ImgError404}  />
    </div>
 
<Button value="Refresh" styleClass="btnPrimary"/>
 
</div>
    </>
  );
};

export default Error;











